export default __webpack_public_path__ + "static/media/Poppins-BlackItalic.563eda3d.ttf";